module.exports = __webpack_public_path__ + "img/yhgh2.fb371a14.png";